export default {
  // Endpoints
  loginEndpoint: "/userauth/oauth/token",
  clientToken: "/userauth/oauth/token",
  countryToken: "/account/api/countries",
  // registerEndpoint: '/jwt/register',
  registerEndpoint: "/account/api/user/create",
  verifyToken: "/account/api/forgot-password",
  resetPasswordRequestEndpoint: "/account/api/forgot-password",
  resetPasswordEndpoint: "/account/api/save-forgot-password",
  refreshEndpoint: "/userauth/oauth/token",
  logoutEndpoint: "/jwt/logout",
  invoiceAddEndpoint: "/account/api/user-invoice/create",
  invoiceEditEndpoint: "/account/api/user-invoice",
  invoiceDeleteEndpoint: "/account/api/user-invoice",
  UserEditEndpoint: "/account/api/user-person",
  UserDeleteEndpoint: "/account/api/user-person",
  SearchCompanyEndpoint: "/index/api/search-companies/search-by-name",
  SearchEicEndpoint: "/index/api/search-companies",
  SearchEicPerson: "/account/api/user-person/search/1/100",

  CompanyInvoiceAddEndpoint: "/account/api/invoice/create",
  companyInvoiceEditEndpoint: "/account/api/invoice",
  bankStatementEditEndpoint: "/account/api/bank-statement/update",
  bankStatementDeleteEndpoint: "/account/api/bank-statement",

  companyInvoiceDeleteEndpoint: "/account/api/invoice",
  UserCompanyDeleteEndpoint: "/account/api/person",
  UserCompanyEditEndpoint: "/account/api/person",

  searchEicPersonCompanies: "/account/api/person/search",
  fileInvoiceEndpoint: "/index/api/invoice/ocr",
  multipleFileInvoiceEndpoint: "/index/api/multiple/invoice/ocr",
  multipleFileBankStatement: "/index/api/multiple/bank-statement/ocr",
  multipleExportFileEndpoint: "/account/api/export",

  //Delete Company
  deleteCompanyEndPoint: "/account/api/company",

  // Vat-Reports
  VatReportAddEndPoint: "/account/api/report/create",
  VatReportEditEndPoint: "/account/api/report/update",
  VatReportDeleteEndPoint: "/account/api/report",

  // Genearte invoice-for-report
  GetInvoicesForReportEndPoint:
    "/account/api/calculation/get-invoices-for-report",
  CreateVatReportZipFileEndPoint: "/account/api/calculation/create-vat-report",

  getCompanies: "/api/company/list/1/10",

  //Getting Plans
  GetPlansEndPoint: "/account/api/payment/plans",
  GetUserCurrentPlan: "/account/api/user/plan/current-plan",

  wrongOldPasswordEndPoint: "/account/api/user/change-password",
  validateVat: "/account/api/company-validate",
  syncWithQuickBookPostEndPoint: "/account/api/qbo-sync-invoice",
  syncWithXeroPostEndPoint: "/account/api/xero-sync-invoice",
  getSupportedPlatformsEndPoint: "/api/export/get-supported-platforms",
  listUSPSByZip: "/account/api/list-usps-by-zip",
  listUSPSByCity: "/account/api/list-usps-by-city",
  decode: "/account/api/decode",
  fedexlistbyShippingCities: "/account/api/list-fedex-by-shipping-city",
  fedexlistbyNoShippingCities: "/account/api/list-fedex-by-city",
  listUPSByShippingState: "/account/api/list-ups-by-shipping-state",
  listUPSByZip: "/account/api/list-ups-by-zip",
  listUSPSByShippingState: "/account/api/list-usps-by-shipping-state",
  listUSPSByShippingCities: "/account/api/list-usps-by-shipping-city",
  listFedexGermeny: "/account/api/list-de",
  listFedexCanada: "/account/api/list-ca",
  listFedexUK: "/account/api/list-uk",
  listCities: "/account/api/cities",
  listFedexUktoUk: "/account/api/list-uk-to-uk",
  listFedexWWWtoDE: "/account/api/list-www-to-de",

  //bulk tracking
  sampleFileUSPSDeliverDate:
    "/account/api/download-example-usps-destination-zip-and-shipping-state-and-delivery-date",

  sampleFileUSPSZip: "/account/api/download-example-usps-only-destination-zip",
  CreateFileUSPSZip: "/account/api/uploadFile-usps-only-destination-zip",
  sampleFileUSPSOnlyDestination:
    "/account/api/download-example-ups-destination-zip-and-shipping-state-and-delivery-date",

  sampleFileUSPSState:
    "/account/api/download-example-usps-destination-zip-and-shipping-state",
  CreateFileUSPSState: "/account/api/uploadFile-usps-shipped-from-state",

  sampleFileUSPSCity:
    "/account/api/download-example-usps-shipping-city-and-destination-city",
  CreateFileUSPSCity: "/account/api/uploadFile-usps-shipped-from-city",

  sampleFileUPSDestination:
    "/account/api/download-example-ups-only-destination-zip",
  CreateFileUPSDestination: "/account/api/uploadFile-ups-only-destination",

  sampleFileUPSShipped:
    "/account/api/download-example-ups-destination-zip-and-shipping-state",
  CreateFileUPSShipped: "/account/api/uploadFile-ups-shipped-from-state",

  sampleFedexStateFile:
    "/account/api/download-example-fedex-shipping-state-and-destination-city-delivery-date",

  sampleFileFedexDestination:
    "/account/api/download-example-fedex-destination-city",
  CreateFileFedexDestination: "/account/api/uploadFile-fedex-only-destination",

  sampleFileFedexShipped:
    "/account/api/download-example-fedex-shipping-state-and-destination-city",
  CreateFileFedexShipped: "/account/api/uploadFile-fedex-shipped-from-city",

  getMyAffiliateAmount: "/account/api/affiliate/get-my-affiliate-amount",

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: "Bearer",

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: "accessToken",
  storageRefreshTokenKeyName: "refreshToken",
};
